import React, {useState} from "react";
import { Typography, Button, Grid, Box, Skeleton } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import "./contactPage.css";
import PhyelementsMain from "../PhyElements/PhyelementsMain";
import SiteFooter from "../OurServices/ASIC/SiteFooter";

const ContactPage = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <>
    <PhyelementsMain/>
    <div className="container">

      <Grid container padding={1} margin={0} rowSpacing={2} columnGap={6}>
        <Grid item xs={12} sm={5} className="office-details">
            <Typography variant="h2" paddingBottom={1}>
              Get In Touch
            </Typography>
            <Typography variant="body2" width={'60%'}>
              We'd love to hear from you. Whether you have questions, need support, or want to learn more about our services, our team is here to help.
            </Typography>            
        </Grid>
        <Grid item xs={12} sm={3} className="office-details">
              <LocationOnOutlinedIcon className="icon" />
              <Typography variant="h3">Corporate Office</Typography>
              <Typography variant="body2">#832, 3rd Floor, 3rd Stage,</Typography>
              <Typography variant="body2">BEML Layout, Raja Rajeshwari Nagar,</Typography>
              <Typography variant="body2">Bengaluru 560 098</Typography>
              <Typography variant="body2">Karnataka, INDIA</Typography>
        </Grid>
        <Grid item xs={12} sm={3} className="office-details">
            <EmailOutlinedIcon className="icon" />
            <Typography variant="h3">Contact Info</Typography>
            <Typography variant="body2">contact@phyelements.com</Typography>
        </Grid>
      </Grid>

      <Box mt={1} textAlign="center">
        {/* Skeleton placeholder */}
        {!mapLoaded && (
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              width: "100%",              
            }}
            />
        )}
        <iframe
          title="Phyelements office location"
          className="map-container"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d403.4843903591554!2d77.52027144348143!3d12.918814036593862!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3fa624092c33%3A0xc9e183cd4232d368!2sPHYELEMENTS%20LLP!5e0!3m2!1sen!2sin!4v1749729725833!5m2!1sen!2sin" 
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          onLoad={() => setMapLoaded(true)}
        ></iframe>

        <Button 
          variant='outlined'
          sx={{ mt: 1, mb:6 }}
          href="https://maps.app.goo.gl/NqC6o1kURhX5W1BcA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get Directions →
        </Button>
        </Box>
    </div>
    <SiteFooter/>
    </>
  );
};

export default ContactPage;
